import { Helmet } from "react-helmet";
import Authority from "../../components/reusables/Authority";
import ICTconsultancy from "../../components/solutions/ictconsultancy/ICTconsultancy";
import SolutionCTA from "../../components/solutions/SolutionCTA";
import HowWeWork from "../../components/solutions/HowWeWork";
import ICTConsultancyFaqsBody from "../../components/faqs/ICTConsultancyFaqsBody";
import RelatedICTconsultancy from "../../components/solutions/ictconsultancy/RelatedICTconsultancy";
import SolutionItemHero from "../../components/reusables/hero/SolutionItemHero";

export default function ICTConsult() {
  return (
    <>
      <Helmet>
        <link
          rel="canonical"
          href="https://www.ntuna.com/solutions/ict-consultancy"
        />
        <meta
          name="description"
          content="Get expert setup and installation of ICT systems and software, and guidance on the ICT direction and implementation of technologies for your business."
        />
        
        <meta
          property="og:description"
          content="Get expert setup and installation of ICT systems and software, and guidance on the ICT direction and implementation of technologies for your business."
        />
        <meta
          property="og:title"
          content="NTUNA.COM | Solutions | ICT Consultancy & Setup"
        />
        <meta
          property="og:image"
          content="https://res.cloudinary.com/malidad/image/upload/v1779627082/ntuna_solutions_banner_1200x628_c8xerm.jpg"
        />

        <meta
          name="twitter:title"
          content="NTUNA.COM | Solutions | ICT Consultancy & Setup"
        />
        <meta
          name="twitter:text:title"
          content="NTUNA.COM | Solutions | ICT Consultancy & Setup"
        />
        <meta
          name="twitter:description"
          content="Get expert setup and installation of ICT systems and software, and guidance on the ICT direction and implementation of technologies for your business."
        />
        <meta
          name="twitter:image"
          content="https://res.cloudinary.com/malidad/image/upload/v1779627082/ntuna_solutions_banner_1200x628_c8xerm.jpg"
        />
        <title>NTUNA.COM | Solutions | ICT Consultancy & Setup</title>
      </Helmet>
      <SolutionItemHero
        title="ICT Consultancy & Setup"
        subtitle="Get expert setup and installation of ICT systems and software, and guidance on the ICT direction and implementation of technologies for your business. From school computer lab to office complete ICT setup and support."
        casestudylink="/#"
        CTAtext="Get Free Quote"
        mainCTAlink="https://form.jotform.com/ntuna/get-free-quote"
      />
      <Authority />
      <ICTconsultancy />
      <SolutionCTA ctaTitle="Ready To Have The ICT Of Your Organization Setup Right?" />
      <ICTConsultancyFaqsBody />
      <SolutionCTA ctaTitle="Ready To Have The ICT Of Your Organization Setup Right?" />
      <HowWeWork />
      <SolutionCTA ctaTitle="Ready To Have The ICT Of Your Organization Setup Right?" />
      <RelatedICTconsultancy />
    </>
  );
}
